import React from 'react';

import useTranslateLpc from '@components/common/hooks/useTranslateLpc';
import Text from '@components/common/Text/Text';
import { ROUTE } from '@services/http/Route';

import css from './BannerMango.module.scss';

const BannerMango = ({ userMail }: { userMail?: string }) => {
    const { t } = useTranslateLpc('common');
    return (
        <div className={css.banner_mango}>
            <div className={css.banner_mango__desc}>
                <Text
                    variant={'mini_label'}
                    color={'white'}
                    customClass={css.banner_mango__desc__text}
                    html
                    htmlText={
                        userMail
                            ? t('mangopay-migration.refused.organizer-refused', {
                                  migrationAccepted:
                                      process.env.BACKEND_BASE_URL +
                                      ROUTE.LPC.ACCEPT_MANGOPAY_CGU_BANNER +
                                      '?email=' +
                                      userMail,
                              })
                            : t('mangopay-migration.refused.not-accessible')
                    }
                />
            </div>
        </div>
    );
};

export default BannerMango;
